import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { HttpMethods, SERVICES } from '../../services/api';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../rootReducer';
import { showSuccessMessage, showErrorMessage } from '../notifications';
import { UpdateAccountPolicy } from './accountFeature';
import { fetchAccountsList } from '../../slices/accounts/list.thunks';
import { Features, isFeatureEnabled } from '../../featureToggles/features';
import { ListParams } from '../utils';
import { FilterOperators, Ifilter } from '../../components/common/filters/interfaces';

export const updateAccountPolicy: AsyncThunk<void, UpdateAccountPolicy, ThunkAPI> = createAsyncThunk(
  'accountPolicy',
  async (keyData: UpdateAccountPolicy, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, UpdateAccountPolicy>({
        endpoint: 'account-features',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })(keyData, thunk);
      thunk.dispatch(showSuccessMessage('Features updated successfully'));
      if (isFeatureEnabled(Features.PlgExternal)) {
        const fetchAccountsRequest: ListParams<Ifilter[]> = {
          filters: [
            {
              field: '_id',
              operands: [keyData.accountId],
              operator: FilterOperators.isAnyOf,
              validateInputs: false
            }
          ],
          pagination: { offset: 0, limit: 25 }
        };
        thunk.dispatch(fetchAccountsList(fetchAccountsRequest));
      }
      return response;
    } catch(err) {
      thunk.dispatch(showErrorMessage(JSON.stringify(err) || 'An error occurred updating features'));
      return thunk.rejectWithValue(err);
    }
  }
);
